import { NgModule } from '@angular/core';
import { DefaultValuePipe } from './default-value.pipe';
import { DateDDMMAAAAPipe } from './date-dd-mm-aaaa.pipe';
import { CpfCnpjPipe } from './cpf-cnpj.pipe';
import { PostalCodePipe } from './postal-code.pipe';
import { DateTimeCompletedPipe } from './date-dd-mm-aaaa-hour-min.pipe';
import { ModalityPipe } from './modality.pipe';
import { CellphonePipe } from './cellphone.pipe';
import { CompanyTypePipe } from './company-type.pipe';

@NgModule({
  declarations: [CpfCnpjPipe, DateDDMMAAAAPipe, DefaultValuePipe, PostalCodePipe, DateTimeCompletedPipe, ModalityPipe, CellphonePipe, CompanyTypePipe],
  exports: [CpfCnpjPipe, DateDDMMAAAAPipe, DefaultValuePipe, PostalCodePipe, DateTimeCompletedPipe, ModalityPipe, CellphonePipe, CompanyTypePipe],
})
export class PipesModule { }
